<template>
  <div class="min-h-screen bg-base-200 py-16 px-4 sm:px-6 lg:px-8">
    <div class="max-w-5xl mx-auto animate-fade-in-up">
      
      <div class="text-center mb-16 space-y-4">
        <h1 class="text-4xl md:text-5xl font-extrabold text-base-content">Join Aanza</h1>
        <p class="text-xl text-base-content/70 max-w-2xl mx-auto">
          Help us build the future of restaurant management. We're looking for passionate individuals to reduce operational friction and create interactive dining experiences.
        </p>
      </div>

      <div class="flex flex-col gap-6">
        <div class="card bg-base-100 shadow-md hover:shadow-xl hover:-translate-y-1 transition-all duration-300">
          <div class="card-body flex flex-col md:flex-row md:items-center justify-between gap-4">
            <div>
              <h2 class="card-title text-2xl text-primary">Frontend Developer</h2>
              <p class="text-base-content/70 mt-1">Remote • Full-time</p>
            </div>
            <button class="btn btn-outline btn-primary">Apply Now</button>
          </div>
        </div>

        <div class="card bg-base-100 shadow-md hover:shadow-xl hover:-translate-y-1 transition-all duration-300">
          <div class="card-body flex flex-col md:flex-row md:items-center justify-between gap-4">
            <div>
              <h2 class="card-title text-2xl text-primary">Backend Engineer</h2>
              <p class="text-base-content/70 mt-1">Remote • Full-time</p>
            </div>
            <button class="btn btn-outline btn-primary">Apply Now</button>
          </div>
        </div>

        <div class="card bg-base-100 shadow-md hover:shadow-xl hover:-translate-y-1 transition-all duration-300">
          <div class="card-body flex flex-col md:flex-row md:items-center justify-between gap-4">
            <div>
              <h2 class="card-title text-2xl text-primary">Sales Executive</h2>
              <p class="text-base-content/70 mt-1">Hybrid • Full-time</p>
            </div>
            <button class="btn btn-outline btn-primary">Apply Now</button>
          </div>
        </div>
      </div>

      <div class="mt-16 text-center bg-primary/10 rounded-2xl p-8">
        <h3 class="text-2xl font-bold mb-2">Don't see a fit?</h3>
        <p class="text-base-content/80 mb-6">We're always looking for talented people. Send your resume to us directly.</p>
        <a href="mailto:careers@aanzamenu.com" class="btn btn-primary">Email Your Resume</a>
      </div>

    </div>
  </div>
</template>

<style scoped>
.animate-fade-in-up {
  animation: fadeInUp 0.6s ease-out;
}
@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}
</style>
